import { HomePageComponentNodeName } from '@ps/isp-web-services-types';

import {
  OddsBoostEvents,
  PopularAccumulators,
  PopularBetBuilders,
  PopularSportsPicker
} from '@swf/sports/features';

import { InPlayEvents } from '../components/InPlayEvents/InPlayEvents';
import { UpcomingEvents } from '../components/UpcomingEvents/UpcomingEvents';

const {
  SPORT_PICKER,
  POPULAR_ACCUMULATORS,
  POPULAR_BET_BUILDERS,
  ODDS_BOOST,
  IN_PLAY,
  UPCOMING_EVENTS,
  CMS_BANNERS,
  FEATURED,
  NEXT_RACES,
  PROMOTION
} = HomePageComponentNodeName;

type HomePageComponent =
  | typeof PopularSportsPicker
  | typeof PopularAccumulators
  | typeof PopularBetBuilders
  | typeof InPlayEvents
  | typeof OddsBoostEvents
  | typeof UpcomingEvents;

export const FALLBACK_COMPONENT_ORDER = [
  SPORT_PICKER,
  ODDS_BOOST,
  POPULAR_ACCUMULATORS,
  POPULAR_BET_BUILDERS,
  IN_PLAY,
  UPCOMING_EVENTS
];

export const COMPONENT_MAP: Record<HomePageComponentNodeName, HomePageComponent | null> = {
  [SPORT_PICKER]: PopularSportsPicker,
  [POPULAR_ACCUMULATORS]: PopularAccumulators,
  [POPULAR_BET_BUILDERS]: PopularBetBuilders,
  [IN_PLAY]: InPlayEvents,
  [ODDS_BOOST]: OddsBoostEvents,
  [UPCOMING_EVENTS]: UpcomingEvents,
  // all components below are not yet moved over to the home-page endpoint
  [CMS_BANNERS]: null,
  [FEATURED]: null,
  [NEXT_RACES]: null,
  [PROMOTION]: null
};
